import { render, staticRenderFns } from "./serviceMonitor.vue?vue&type=template&id=1bbcb304"
import script from "./serviceMonitor.vue?vue&type=script&lang=js"
export * from "./serviceMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports